(function(){
  var sticky=document.querySelector('[data-fx-sticky]'), buy=document.querySelector('#fx-buy .fx-buybox'), offer=document.getElementById('offer');
  if(!sticky||!buy||!('IntersectionObserver' in window)) return;
  var buyVisible=true, buyPassed=false, offerVisible=false;
  function paint(){ sticky.hidden = !(buyPassed && !buyVisible && !offerVisible); }
  new IntersectionObserver(function(e){ buyVisible=e[0].isIntersecting; buyPassed=e[0].boundingClientRect.top<0; paint(); }).observe(buy);
  if(offer) new IntersectionObserver(function(e){ offerVisible=e[0].isIntersecting; paint(); }).observe(offer);
})();
/* UTMify: give the pixel a moment to send Initiate Checkout before leaving the page */
(function(){
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form || !form.querySelector || !form.querySelector('.btn-compra')) return;
    if(form.dataset.fxSent==='1') return;
    e.preventDefault();
    form.dataset.fxSent='1';
    var btn=form.querySelector('button.btn-compra'); if(btn) btn.setAttribute('aria-busy','true');
    setTimeout(function(){ HTMLFormElement.prototype.submit.call(form); },450);
  },false);
})();
/* Videos play inline, inside the card (no fullscreen popup) + arrows */
(function(){
  function paint(card, paused){
    card.classList.toggle('is-paused', paused);
    var label=card.getAttribute('data-fx-label') || card.getAttribute('aria-label') || '';
    card.setAttribute('aria-label', label + (paused ? ' — Play' : ' — Pause'));
  }
  function reset(card){
    card.classList.remove('is-playing', 'is-paused');
    var label=card.getAttribute('data-fx-label');
    if(label!==null) card.setAttribute('aria-label', label);
  }
  function stopAll(except){
    document.querySelectorAll('.fx-vcard.is-playing, .fx-vthumb.is-playing').forEach(function(c){
      if(c===except) return;
      var v=c.querySelector('video'); if(v){ v.pause(); v.remove(); }
      reset(c);
    });
  }
  function playVideo(v, card){
    var p=v.play();
    if(p && p.catch) p.catch(function(){ if(card.contains(v)) paint(card, true); });
  }
  function playIn(card){
    var existing=card.querySelector('video');
    if(existing){
      if(existing.paused){ stopAll(card); playVideo(existing, card); }
      else existing.pause();
      return;
    }
    var src=card.getAttribute('data-fx-video'); if(!src) return;
    stopAll(card);
    if(!card.hasAttribute('data-fx-label')) card.setAttribute('data-fx-label', card.getAttribute('aria-label') || 'Video');
    var v=document.createElement('video');
    v.src=src; v.controls=false; v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
    v.setAttribute('disablepictureinpicture','');
    v.className='fx-inline-video';
    var poster=card.querySelector('img'); if(poster) v.poster=poster.currentSrc||poster.src;
    v.addEventListener('play',function(){ paint(card, false); });
    v.addEventListener('pause',function(){ paint(card, true); });
    v.addEventListener('ended',function(){ v.remove(); reset(card); });
    v.addEventListener('error',function(){ v.remove(); reset(card); });
    card.appendChild(v); card.classList.add('is-playing'); paint(card, true);
    playVideo(v, card);
  }
  document.addEventListener('click',function(e){
    var card=e.target.closest && e.target.closest('[data-fx-video]'); if(!card) return;
    e.preventDefault(); playIn(card);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter' && e.key!==' ') return;
    var card=e.target.closest && e.target.closest('[data-fx-video]'); if(!card) return;
    e.preventDefault(); if(!e.repeat) playIn(card);
  });
  document.querySelectorAll('[data-fx-vtrack]').forEach(function(track){
    var sec=track.closest('section');
    function step(dir){ var c=track.querySelector('.fx-vcard'); var w=c?c.getBoundingClientRect().width+18:280; track.scrollBy({left:dir*w,behavior:'smooth'}); }
    var pv=sec.querySelector('[data-fx-vprev]'), nx=sec.querySelector('[data-fx-vnext]');
    if(pv) pv.addEventListener('click',function(){step(-1)}); if(nx) nx.addEventListener('click',function(){step(1)});
  });
})();
